import { Plan2PlateDrawer, Plan2PlateDrawerHeader } from "./Plan2PlateDrawer";
import React from "react";
import { FoodEditor } from "./FoodEditor";
import Food from "../data/food";

export function EditFoodDrawer(props: {
  onClose: () => void;
  open: boolean;
  onSubmit: (d: Food) => void | Promise<void>;
  food?: Food;
  allowUnitDeletion: boolean;
}) {
  return props.food ? (
    <Plan2PlateDrawer
      onClose={props.onClose}
      open={props.open}
      header={<Plan2PlateDrawerHeader heading={"Lebensmittel bearbeiten"} />}
      body={
        <FoodEditor
          initialFood={props.food}
          isCreate={false}
          afterSave={(createdFood: Food) => {
            props.onClose();
            props.onSubmit(createdFood);
          }}
          allowUnitDeletion={props.allowUnitDeletion}
        />
      }
    />
  ) : (
    <></>
  );
}
